class ColumnSlider extends HTMLElement {
  // connect component
  connectedCallback() {
    const breakpoint = window.matchMedia("(max-width: 750px)");
    let columnSlider;
    const checkBreakpoint = function () {
      const allSliders = document.querySelectorAll(".swiper-column-slider");
      allSliders.forEach((slider) => {
        if (breakpoint.matches === false) {
          if (slider.swiper) {
            disableSlider(slider.swiper);
          }
          // enable slider on mobile
        } else if (breakpoint.matches === true) {
          if (!slider.classList.contains("swiper-initialized")) {
            enableSlider(slider);
          }
        }
      });
    };
    const enableSlider = function (slider) {
      const sliderId = slider.id;
      let slideCount = slider.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate)"
      ).length;
      if (slideCount > 1) {
        new Swiper(`#${sliderId}`, {
          pagination: {
              el: `#${sliderId} .swiper-pagination`,
              clickable: true
          },
        });
      }
    };

    const disableSlider = function (slider) {
      if (slider !== undefined) {
        slider.destroy(true, true);
      }
    };

    breakpoint.addListener(checkBreakpoint);
    checkBreakpoint(); // first check
  }
}

customElements.define("column-slider", ColumnSlider);
